import React from 'react'

import { TextField, Grid, Typography } from "@mui/material"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BooleanFilter from '../../core/form/BooleanFilter';
import { useSelector, useDispatch } from 'react-redux';
import { setPharmaorderFilterCriteria } from 'store/slice/PharmaSlice';

export default function PharmaorderFilterCriteriaImpl() {
    const dispatch = useDispatch();
    const { filterCriteria } = useSelector((state) => state.pharmaslice.pharmaorderDashboard);
    const salesList = useSelector((state) => state.headerslice.myBusinessUserList)
        .filter(user => user.rolename === 'PHARMA_OMS_SALES');
    const { partyList } = useSelector((state) => state.pharmaslice);

    const updateExecutivenameCriteria = (executivename) => {
        dispatch(setPharmaorderFilterCriteria({
            ...filterCriteria,
            executivename: executivename === 'all' ? '' : executivename // Ignore filter if 'all' is selected
        }))
    }
    const updatePartynameCriteria = (partyname) => {
        dispatch(setPharmaorderFilterCriteria(
            {
                ...filterCriteria,
                partyname: partyname
            }))
    }
    const updateOrderidCriteria = (orderid) => {
        dispatch(setPharmaorderFilterCriteria(
            {
                ...filterCriteria,
                orderid: orderid
            }))
    }
    const updateOrderstatusCriteria = (orderstatus) => {
        dispatch(setPharmaorderFilterCriteria(
            {
                ...filterCriteria,
                orderstatus: orderstatus
            }))
    }
    const updateBrandnameCriteria = (brandname) => {
        dispatch(setPharmaorderFilterCriteria({
            ...filterCriteria,
            brandname: brandname
        }))
    }

    return (

        <Grid container direction="row" lg={12} sx={{ justifyContent: 'space-between', width: '100%', backgroundColor: 'white' }}>
            <Grid item lg={2} padding={1}>
                <TextField type="search"
                    label="Orderid"
                    name="orderid"
                    value={filterCriteria.orderid}
                    onChange={(e) => updateOrderidCriteria(e.target.value)}
                    sx={{ width: '100%' }}
                />
            </Grid>
            <Grid item lg={2} padding={1}>
                <FormControl style={{ width: '100%' }} size="small">
                    <InputLabel id="executivename-label">Executive</InputLabel>
                    <Select
                        labelId="executivename-label"
                        id="executivename"
                        value={filterCriteria.executivename || 'all'}
                        name="executivename"
                        label="Executive"
                        onChange={e => updateExecutivenameCriteria(e.target.value)}
                        sx={{p:.25}}
                    >
                        <MenuItem value="all">All</MenuItem>
                        {salesList.map(user => (
                            <MenuItem key={user.id} value={user.username}>
                                {user.username}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item lg={3} padding={1}>
                <TextField type="search"
                    label="Partyname"
                    name="partyname"
                    value={filterCriteria.partyname}
                    onChange={(e) => updatePartynameCriteria(e.target.value)}
                    sx={{ width: '100%' }}
                />
            </Grid>
            <Grid item lg={3} padding={1}>
                <TextField
                    type="search"
                    label="Brand Name"
                    name="brandname"
                    value={filterCriteria.brandname || ''}
                    onChange={e => updateBrandnameCriteria(e.target.value)}
                    sx={{ width: '100%' }}
                />
            </Grid>
            <Grid item lg={2} padding={1}>
                <FormControl style={{ width: '100%' }} size="small">
                    <InputLabel id="ratinginput">Status</InputLabel>
                    <Select
                        labelId="orderstatusselect"
                        id="orderstatus"
                        value={filterCriteria.orderstatus}
                        name="orderstatus"
                        label="Status"
                        onChange={(e) => updateOrderstatusCriteria(e.target.value)}
                        sx={{p:.25}}
                    //defaultValue={orderstatus}
                    >
                        <MenuItem value="">All</MenuItem>

                        <MenuItem value="DRAFT">DRAFT</MenuItem>
                        <MenuItem value="APPROVAL">APPROVAL</MenuItem>
                        <MenuItem value="PRODUCTION">PRODUCTION</MenuItem>
                        <MenuItem value="DELIVERED">DELIVERED</MenuItem>
                    </Select>
                </FormControl>
            </Grid>


        </Grid>
    )

}